module.exports = __webpack_public_path__ + "img/bg.078bca08.png";